/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ExecutionHourInconsistencyResponse } from '../models/execution-hour-inconsistency-response';
import { ExecutionHourLacResponse } from '../models/execution-hour-lac-response';
import { getFeV1OtherExecutionHourInconsistency$Json } from '../fn/other/get-fe-v-1-other-execution-hour-inconsistency-json';
import { GetFeV1OtherExecutionHourInconsistency$Json$Params } from '../fn/other/get-fe-v-1-other-execution-hour-inconsistency-json';
import { getFeV1OtherExecutionHourInconsistency$Plain } from '../fn/other/get-fe-v-1-other-execution-hour-inconsistency-plain';
import { GetFeV1OtherExecutionHourInconsistency$Plain$Params } from '../fn/other/get-fe-v-1-other-execution-hour-inconsistency-plain';
import { getFeV1OtherExecutionHourLac$Json } from '../fn/other/get-fe-v-1-other-execution-hour-lac-json';
import { GetFeV1OtherExecutionHourLac$Json$Params } from '../fn/other/get-fe-v-1-other-execution-hour-lac-json';
import { getFeV1OtherExecutionHourLac$Plain } from '../fn/other/get-fe-v-1-other-execution-hour-lac-plain';
import { GetFeV1OtherExecutionHourLac$Plain$Params } from '../fn/other/get-fe-v-1-other-execution-hour-lac-plain';
import { putFeV1OtherExecutionHourLac$Json } from '../fn/other/put-fe-v-1-other-execution-hour-lac-json';
import { PutFeV1OtherExecutionHourLac$Json$Params } from '../fn/other/put-fe-v-1-other-execution-hour-lac-json';
import { putFeV1OtherExecutionHourLac$Plain } from '../fn/other/put-fe-v-1-other-execution-hour-lac-plain';
import { PutFeV1OtherExecutionHourLac$Plain$Params } from '../fn/other/put-fe-v-1-other-execution-hour-lac-plain';

@Injectable({ providedIn: 'root' })
export class OtherService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getFeV1OtherExecutionHourLac()` */
  static readonly GetFeV1OtherExecutionHourLacPath = '/v1/other/execution-hour-lac';

  /**
   * Gets the execution hour configuration for LAC events.
   *
   * Gets the execution hour configuration for LAC events.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeV1OtherExecutionHourLac$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1OtherExecutionHourLac$Plain$Response(params?: GetFeV1OtherExecutionHourLac$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ExecutionHourLacResponse>> {
    return getFeV1OtherExecutionHourLac$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the execution hour configuration for LAC events.
   *
   * Gets the execution hour configuration for LAC events.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeV1OtherExecutionHourLac$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1OtherExecutionHourLac$Plain(params?: GetFeV1OtherExecutionHourLac$Plain$Params, context?: HttpContext): Observable<ExecutionHourLacResponse> {
    return this.getFeV1OtherExecutionHourLac$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExecutionHourLacResponse>): ExecutionHourLacResponse => r.body)
    );
  }

  /**
   * Gets the execution hour configuration for LAC events.
   *
   * Gets the execution hour configuration for LAC events.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeV1OtherExecutionHourLac$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1OtherExecutionHourLac$Json$Response(params?: GetFeV1OtherExecutionHourLac$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ExecutionHourLacResponse>> {
    return getFeV1OtherExecutionHourLac$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the execution hour configuration for LAC events.
   *
   * Gets the execution hour configuration for LAC events.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeV1OtherExecutionHourLac$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1OtherExecutionHourLac$Json(params?: GetFeV1OtherExecutionHourLac$Json$Params, context?: HttpContext): Observable<ExecutionHourLacResponse> {
    return this.getFeV1OtherExecutionHourLac$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExecutionHourLacResponse>): ExecutionHourLacResponse => r.body)
    );
  }

  /** Path part for operation `putFeV1OtherExecutionHourLac()` */
  static readonly PutFeV1OtherExecutionHourLacPath = '/v1/other/execution-hour-lac';

  /**
   * Sets the execution hour configuration for LAC events.
   *
   * Sets the execution hour configuration for LAC events.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putFeV1OtherExecutionHourLac$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putFeV1OtherExecutionHourLac$Plain$Response(params?: PutFeV1OtherExecutionHourLac$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ExecutionHourLacResponse>> {
    return putFeV1OtherExecutionHourLac$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Sets the execution hour configuration for LAC events.
   *
   * Sets the execution hour configuration for LAC events.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putFeV1OtherExecutionHourLac$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putFeV1OtherExecutionHourLac$Plain(params?: PutFeV1OtherExecutionHourLac$Plain$Params, context?: HttpContext): Observable<ExecutionHourLacResponse> {
    return this.putFeV1OtherExecutionHourLac$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExecutionHourLacResponse>): ExecutionHourLacResponse => r.body)
    );
  }

  /**
   * Sets the execution hour configuration for LAC events.
   *
   * Sets the execution hour configuration for LAC events.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putFeV1OtherExecutionHourLac$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putFeV1OtherExecutionHourLac$Json$Response(params?: PutFeV1OtherExecutionHourLac$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ExecutionHourLacResponse>> {
    return putFeV1OtherExecutionHourLac$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Sets the execution hour configuration for LAC events.
   *
   * Sets the execution hour configuration for LAC events.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putFeV1OtherExecutionHourLac$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putFeV1OtherExecutionHourLac$Json(params?: PutFeV1OtherExecutionHourLac$Json$Params, context?: HttpContext): Observable<ExecutionHourLacResponse> {
    return this.putFeV1OtherExecutionHourLac$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExecutionHourLacResponse>): ExecutionHourLacResponse => r.body)
    );
  }

  /** Path part for operation `getFeV1OtherExecutionHourInconsistency()` */
  static readonly GetFeV1OtherExecutionHourInconsistencyPath = '/v1/other/execution-hour-inconsistency';

  /**
   * Gets the execution hour configuration for Inconsistency events.
   *
   * Gets the execution hour configuration for Inconsistency events.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeV1OtherExecutionHourInconsistency$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1OtherExecutionHourInconsistency$Plain$Response(params?: GetFeV1OtherExecutionHourInconsistency$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ExecutionHourInconsistencyResponse>> {
    return getFeV1OtherExecutionHourInconsistency$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the execution hour configuration for Inconsistency events.
   *
   * Gets the execution hour configuration for Inconsistency events.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeV1OtherExecutionHourInconsistency$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1OtherExecutionHourInconsistency$Plain(params?: GetFeV1OtherExecutionHourInconsistency$Plain$Params, context?: HttpContext): Observable<ExecutionHourInconsistencyResponse> {
    return this.getFeV1OtherExecutionHourInconsistency$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExecutionHourInconsistencyResponse>): ExecutionHourInconsistencyResponse => r.body)
    );
  }

  /**
   * Gets the execution hour configuration for Inconsistency events.
   *
   * Gets the execution hour configuration for Inconsistency events.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeV1OtherExecutionHourInconsistency$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1OtherExecutionHourInconsistency$Json$Response(params?: GetFeV1OtherExecutionHourInconsistency$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ExecutionHourInconsistencyResponse>> {
    return getFeV1OtherExecutionHourInconsistency$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the execution hour configuration for Inconsistency events.
   *
   * Gets the execution hour configuration for Inconsistency events.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeV1OtherExecutionHourInconsistency$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1OtherExecutionHourInconsistency$Json(params?: GetFeV1OtherExecutionHourInconsistency$Json$Params, context?: HttpContext): Observable<ExecutionHourInconsistencyResponse> {
    return this.getFeV1OtherExecutionHourInconsistency$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExecutionHourInconsistencyResponse>): ExecutionHourInconsistencyResponse => r.body)
    );
  }

}
